// @dynamic-i18n-keys
// handled by script
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Check from '@wix/da-ds/pkg/Icons/Check';
import Error from '@wix/da-ds/pkg/Icons/24x24/Error';
import { genericUndoAction } from '../../Notifications/redux/actionCreators';
import SystemNotification from '../../SystemNotification';
import Notification from '../Notification';

export interface Props {
  id: number;
  queueName: string;
  message?: string;
  messageLocaleKey?: string | string[];
  messageLocaleOptions?: Record<string, unknown>;
  isError?: boolean;
  cardProps?: any;
}

export const GenericUndoNotification: React.FC<
  React.PropsWithChildren<Props>
> = ({
  id,
  queueName,
  message,
  messageLocaleKey,
  messageLocaleOptions,
  isError = false,
  cardProps = {},
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const onUndo = useCallback(() => {
    dispatch(genericUndoAction());
  }, [dispatch]);

  return (
    <Notification
      id={id}
      queueName={queueName}
      cardComponent={SystemNotification}
      cardProps={{
        iconComponent: isError ? Error : Check,
        isError,
        ...cardProps,
        actions: [
          onUndo && {
            type: 'positive',
            label: t('common.undo'),
            onClick: onUndo,
            closeOnClick: true,
          },
          ...(cardProps?.actions || []),
        ],
      }}
    >
      {message ??
        (t(messageLocaleKey ?? '', messageLocaleOptions) as React.ReactNode)}
    </Notification>
  );
};
GenericUndoNotification.displayName = 'GenericUndoNotification';

export default GenericUndoNotification;
